import React, { useState, useEffect } from 'react';
import { MDXProvider } from '@mdx-js/react';

import { Helmet } from 'react-helmet';

import LoadingSpinner from '../components/loading-spinner/LoadingSpinner';

import PrepaidOneTimeTopup from '../components/forms/PrepaidOneTimeTopup';
import PrepaidCardTopup from '../components/forms/PrepaidCardTopup';

import PostpaidOneTimeTopup from '../components/forms/PostpaidOneTimeTopup';

import PaymentResponse from '../components/forms/PaymentResponse';

import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';

import '../components/static/st-utility.css';
import '../components/static/fonts.css';

const shortcodes = {
  PrepaidOneTimeTopup,
  PrepaidCardTopup,
  PostpaidOneTimeTopup,
  PaymentResponse,
  Header,
  Footer,
  LoadingSpinner,
};

const App = ({ children }) => {
  const [isSearchToggled, setisSearchToggled] = useState(false);
  const [isHamburgerToggled, setisHamburgerToggled] = useState(false);

  useEffect(() => {
    const isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
    const isNotLocalhost = typeof window !== 'undefined' && !window.location.href.includes('localhost');

    if (isBrowser && isNotLocalhost) {
      window.dataLayerAdobe = window.dataLayerAdobe || [];

      const pageTitle = document.title;
      const pageName = `payment:${pageTitle
        .toLowerCase()
        .replace('sasktel.com | ', '')
        .replace(/ /g, '-')}`;

      window.dataLayerAdobe.push({
        event: 'Page Viewed',
        page: {
          pageInfo: {
            pageName: pageName,
            pageTitle: pageTitle,
            pageType: 'payment-form',
            pageURL: window.location.pathname,
            serverName: window.location.hostname,
            site: 'payment',
            platform: 'web',
          },
        },
        category: {
          primaryCategory: 'payment',
          subCategory1: window.location.href.split('/').slice(-3)[0],
        },
        version: '1.0',
      });
    }
  }, []);

  const onClickSearch = () => {
    setisSearchToggled(!isSearchToggled);
    console.log('search =' + { isSearchToggled });
  };
  const onClickHamburger = () => {
    setisHamburgerToggled(!isHamburgerToggled);
    console.log('hamburger =' + { isHamburgerToggled });
  };

  return (
    <div className={isHamburgerToggled ? 'flex flex-col h-screen overflow-hidden' : 'flex flex-col h-screen'}>
      <Helmet>
        <meta name="referrer" content="no-referrer-when-downgrade" />
      </Helmet>
      <Header isSearchToggled={isSearchToggled} isHamburgerToggled={isHamburgerToggled} clickSearch={onClickSearch} clickHamburger={onClickHamburger} />
      <LoadingSpinner />
      <MDXProvider components={shortcodes}>{children}</MDXProvider>
      <Footer isHamburgerToggled={isHamburgerToggled} />
    </div>
  );
};

export default App;
